import { render } from "./surface-input.vue?vue&type=template&id=143225c9&scoped=true&ts=true"
import script from "./surface-input.vue?vue&type=script&lang=ts"
export * from "./surface-input.vue?vue&type=script&lang=ts"

import "./surface-input.vue?vue&type=style&index=0&id=143225c9&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143225c9"]])

export default __exports__